import {get} from 'lodash';
import schema from './payment_db';
import * as utils from "./utils";
import {edit} from './sample';
import i18n from 'src/i18n/index';
import debug from 'src/debug';

export function title(model) {
  return get(model, 'payment_id') || i18n.s('schema.payment');
}

export const columns = utils.columnsFn(schema);

export const list = utils.listFn('getPayments');
export const view = utils.viewFn('/admin/payments/:id');
export const read = utils.readFn('getPaymentById', 'payment_id');

export {edit};

export function formActions(model, schema, readonly) {
  let temp = [];
  if (!readonly) {
    temp.push({
      label: i18n.fr('action.save'),
      class: 'btn-success',
      validation: true,
      action: utils.updateFn('updatePayment', 'payment_id', [
        // 'transaction_progress'
      ]),
    });
  }
  if (debug.DEBUG) {
    temp.push({
      label: i18n.fr('action.delete') + ' [Del]',
      class: 'btn-danger',
      trigger: e => e.keyCode === 46,
      action: utils.formActions.delete(
        'deletePaymentById',
        'payment_id',
        '/admin/payments'),
    });
  }
  temp.push(utils.formActions.back);
  return temp;
}



// WEBPACK FOOTER //
// ./src/schemas/payment.js